import React,{useState} from 'react'
import Filter from 'components/search/filter'
import Beranda from 'components/search/BerandaSearch'
import Search from 'components/home/SearchWithoutField'
import './style.css'
export default function Index() {
    return (
        <div>
           
            <div className='layout-container'>
                <div className='home-grid'>
                    <div className='left-grid'>
                        <Filter/>
                    </div>
                    <div className='center-grid'>
                        <Beranda/>
                    </div>
                    <div className='right-grid'>
                        <Search/>
                    </div>
                </div>
            </div>
            <br/><br/><br/>
        </div>
    )
}
